import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { currentPageReportTemplate } from "../../../utilities/TableUtil";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P243List({ dataTable = [], setChange = () => {}, setActionDetail }) {
    const headerLabel = <span className="hidden-responsive">ข้อมูลประกอบการประเมิน</span>;
    const actionDetail = () => setActionDetail({ page: "244" });

    const header = (
        <div className="table-header">
            <span></span>
            <Button className="p-button p-button-success btn-hidden-responsive " label={headerLabel} icon="fa fa-info" onClick={() => actionDetail()} />
        </div>
    );

    const radioColumn = (rowData, checkColumn, titleShow, val, name, change) => {
        const data = { ...rowData };
        const datavalue = data[`${checkColumn}`];

        return (
            <React.Fragment>
                {data.inputFlag === "Y" && (
                    <div>
                        <span className="p-column-title">{titleShow}</span>
                        <RadioButton value={val} name={name} checked={datavalue == val} onChange={(e) => change(rowData, e.value)} />
                    </div>
                )}
            </React.Fragment>
        );
    };

    const normalColumn = (rowData, checkColumn, titleShow) => {
        let data = { ...rowData };
        let datavalue = data[`${checkColumn}`];
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                {datavalue && datavalue !== "" && datavalue !== "null" ? datavalue : ""}
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable value={dataTable} dataKey="id" header={header} currentPageReportTemplate={currentPageReportTemplate()} emptyMessage="ไม่พบข้อมูล" className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify" selectionMode="single">
                    <Column field="itemGroupId" header="ลำดับที่" body={(e) => normalColumn(e, "itemGroupId", "ลำดับที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemDesc" header="รายการประเมิน" body={(e) => normalColumn(e, "itemDesc", "รายการประเมิน")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                    <Column field="itemWeight" header="น้ำหนัก" body={(e) => normalColumn(e, "itemWeight", "น้ำหนัก")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemPoint" header="น้ำหนักXคะแนน" body={(e) => normalColumn(e, "itemPoint", "น้ำหนัก%คะแนน")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemScore" header="ดีมาก(5)" body={(e) => radioColumn(e, "itemScore", "ดีมาก(5)", "5", "", setChange)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemScore" header="ดี(4)" body={(e) => radioColumn(e, "itemScore", "ดี(4)", "4", "", setChange)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemScore" header="พอใช้(3)" body={(e) => radioColumn(e, "itemScore", "พอใช้(3)", "3", "", setChange)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemScore" header="ปรับปรุง(2)" body={(e) => radioColumn(e, "itemScore", "ปรับปรุง(2)", "2", "", setChange)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="itemScore" header="ต้องแก้ไข(1)" body={(e) => radioColumn(e, "itemScore", "ต้องแก้ไข(1)", "1", "", setChange)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
